const BASE = 'app/sessions/';

const ADD_SESSION = BASE + 'ADD_SESSION';

export default {
  ADD_SESSION,
};
